import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

import { useActiveSectionContext } from "../context/active-section-context";
import type { SectionName } from "./types";

export const useSectionInView = (
  sectionName: SectionName,
  threshold = 0.75
) => {
  const { ref, inView } = useInView({
    threshold,
  });

  const { setActiveSection, timeOfLastClick } = useActiveSectionContext() || {};

  useEffect(() => {
    if (inView && Date.now() - (timeOfLastClick || 0) > 1000) {
      setActiveSection?.(sectionName);
    }
  }, [inView, setActiveSection, timeOfLastClick, sectionName]);

  return {
    ref,
  };
};

export const useIsMobileView = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []); 

  return isMobile;
}
